import { login, logout } from '@/api/user'
// import { getStoreUploadPic } from '@/api/upLoad'
import { SESSION_ID, GET_TOEKN } from '@/config'
const user = {
  state: {
    id: '',
    name: '',
    avatar: '',
    roles: [],
    loginId: '',
    type: '',
    UploadPic: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      localStorage.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
      localStorage.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ID: (state, id) => {
      state.id = id
      localStorage.id = id
    },
    SET_LOGINID: (state, loginId) => {
      state.loginId = loginId
      localStorage.loginId = loginId
    },
    SET_TYPE: (state, type) => {
      state.type = type
    },
    SET_UploadPic: (state, type) => {
      state.UploadPic = type
    }
  },
  actions: {
    // 登錄
    login ({ commit }, option) {
      return new Promise((resolve, reject) => {
        login({ data: option, method: 'POST'}).then(res => {
          if (res.code == 400) {
            resolve(res)
          } else {
            commit('SET_TOKEN', res.token)
            commit('SET_ID', res.storeId)
            commit('SET_NAME', res.storeName)
            resolve()
          }
        })
      })
    },
    getImgURL ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getStoreUploadPic()
          .then(res => {
            commit('SET_UploadPic', res)
          })
      })
    },
    // 退出
    logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({
          params: {
            id: localStorage.id,
            sessionId: SESSION_ID,
            token: GET_TOEKN()
          }
        })
          .then(res => {
            localStorage.clear()
            commit('SET_TOKEN', '')
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default user
